export enum PolicyStatus {
    ACTIVE = 'active',
    CANCELLED = 'cancelled',
    SUSPENDED = 'suspended',
    CLOSED = 'closed',
}
